// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"152":"e85f05e2","812":"d9b0cd38","825":"f7c3d41b","915":"96f14a1a"}[chunkId] + ".js";
};